import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[pluginsAccordionHeader]',
})
export class AccordionHeaderDirective {}
